import { Typography } from 'antd';

const { Text, Title } = Typography;

export default function CountCard({
  count,
  label,
  icon,
  iconBg,
  iconColor,
  countColor
}) {
  return (
    <div
      className={
        '!rounded-lg bg-[#fff] !py-2 !px-4 relative shadow-bottom !m-0 !p-0'
      }
      bordered={false}
    >
      <div>
        <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
          {label}
        </Text>
        <Title level={3} style={{ margin: '4px 0 0 0', color: countColor }}>
          {count}
        </Title>
      </div>
      <div
        className={
          ' absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center'
        }
        style={{
          backgroundColor: iconBg,
          color: iconColor
        }}
      >
        {icon}
      </div>
    </div>
  );
}
